// // src/components/common/Navbar.jsx
// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { FaBars, FaTimes, FaUser } from 'react-icons/fa';
// import { useAuth } from '../../context/AuthContext';

// const Navbar = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const { user, signOut, isAdmin } = useAuth();
//   const navigate = useNavigate();

//   const navItems = [
//     { name: 'Home', path: '/' },
//     { name: 'Services', path: '/services' },
//     { name: 'Projects', path: '/projects' },
//     { name: 'About Us', path: '/about' },
//     { name: 'Contact', path: '/contact' },
//     { name: 'Certificates', path: '/certifications' },
//   ];

//   const handleLogout = () => {
//     signOut();
//     navigate('/');
//   };

//   return (
//     <nav className="bg-white shadow-lg fixed w-full z-50">
//       <div className="container-custom">
//         <div className="flex justify-between items-center h-16">
//           {/* Logo with custom image */}
//           <Link to="/" className="flex items-center space-x-3">
//             {/* Replace with your company logo */}
//             <img 
//               src="/company_logo." // Path to your logo in public folder
//               alt="Brasotech Investments Logo"
//               className="h-10 w-auto" // Adjust height as needed
//               onError={(e) => {
//                 e.target.onerror = null; // Prevent infinite loop
//                 // Fallback to text if logo fails to load
//                 e.target.style.display = 'none';
//                 const parent = e.target.parentElement;
//                 if (parent) {
//                   const fallback = document.createElement('div');
//                   fallback.className = 'h-10 w-10 bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg flex items-center justify-center text-white font-bold text-sm';
//                   fallback.textContent = 'BI';
//                   parent.insertBefore(fallback, parent.firstChild);
//                 }
//               }}
//             />
//             <div>
//               <span className="text-xl font-bold text-gray-800">Brasotech</span>
//               <span className="text-sm text-blue-600 block md:inline md:ml-1">Investments Limited</span>
//             </div>
//           </Link>

//           {/* Desktop Navigation */}
//           <div className="hidden md:flex items-center space-x-8">
//             {navItems.map((item) => (
//               <Link
//                 key={item.name}
//                 to={item.path}
//                 className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium"
//               >
//                 {item.name}
//               </Link>
//             ))}

//             {/* User/Auth Section */}
//             <div className="flex items-center space-x-4">
//               {user ? (
//                 <div className="relative group">
//                   <button className="flex items-center space-x-2 text-gray-700 hover:text-blue-600">
//                     <FaUser className="h-5 w-5" />
//                     <span>{user.name || user.email}</span>
//                   </button>
//                   <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-2 hidden group-hover:block">
//                     {isAdmin() && (
//                       <Link
//                         to="/admin"
//                         className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
//                       >
//                         Admin Dashboard
//                       </Link>
//                     )}
//                     <button
//                       onClick={handleLogout}
//                       className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
//                     >
//                       Logout
//                     </button>
//                   </div>
//                 </div>
//               ) : (
//                 <Link
//                   to="/login"
//                   className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-200"
//                 >
//                   Login
//                 </Link>
//               )}
//             </div>
//           </div>

//           {/* Mobile menu button */}
//           <button
//             onClick={() => setIsOpen(!isOpen)}
//             className="md:hidden text-gray-700 focus:outline-none"
//           >
//             {isOpen ? <FaTimes className="h-6 w-6" /> : <FaBars className="h-6 w-6" />}
//           </button>
//         </div>

//         {/* Mobile Navigation */}
//         {isOpen && (
//           <div className="md:hidden bg-white border-t mt-2 py-4">
//             {/* Mobile Logo */}
//             <div className="flex items-center px-4 mb-4">
//               <img 
//                 src="/logo.png" // Same logo for mobile
//                 alt="Brasotech Investments Logo"
//                 className="h-8 w-auto mr-3"
//                 onError={(e) => {
//                   e.target.onerror = null;
//                   e.target.style.display = 'none';
//                   const parent = e.target.parentElement;
//                   if (parent) {
//                     const fallback = document.createElement('div');
//                     fallback.className = 'h-8 w-8 bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg flex items-center justify-center text-white font-bold text-sm mr-3';
//                     fallback.textContent = 'BI';
//                     parent.insertBefore(fallback, parent.firstChild);
//                   }
//                 }}
//               />
//               <div>
//                 <div className="font-bold text-gray-800">Brasotech</div>
//                 <div className="text-xs text-blue-600">Investments Limited</div>
//               </div>
//             </div>

//             {navItems.map((item) => (
//               <Link
//                 key={item.name}
//                 to={item.path}
//                 className="block py-2 px-4 text-gray-700 hover:bg-gray-100"
//                 onClick={() => setIsOpen(false)}
//               >
//                 {item.name}
//               </Link>
//             ))}
//             {user ? (
//               <>
//                 {isAdmin() && (
//                   <Link
//                     to="/admin"
//                     className="block py-2 px-4 text-gray-700 hover:bg-gray-100"
//                     onClick={() => setIsOpen(false)}
//                   >
//                     Admin Dashboard
//                   </Link>
//                 )}
//                 <button
//                   onClick={() => {
//                     handleLogout();
//                     setIsOpen(false);
//                   }}
//                   className="block w-full text-left py-2 px-4 text-gray-700 hover:bg-gray-100"
//                 >
//                   Logout
//                 </button>
//               </>
//             ) : (
//               <Link
//                 to="/login"
//                 className="block py-2 px-4 text-blue-600 hover:bg-blue-50"
//                 onClick={() => setIsOpen(false)}
//               >
//                 Login
//               </Link>
//             )}
//           </div>
//         )}
//       </div>
//     </nav>
//   );
// };

// export default Navbar;






// src/components/common/Navbar.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes, FaUser } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, signOut, isAdmin } = useAuth();
  const navigate = useNavigate();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Certificates', path: '/certifications' },
  ];

  const handleLogout = () => {
    signOut();
    navigate('/');
  };

  return (
    <nav className="bg-white shadow-lg fixed w-full z-50">
      <div className="container-custom">
        <div className="flex justify-between items-center h-16">
          {/* Logo with custom image */}
          <Link to="/" className="flex items-center space-x-3">
            {/* Fixed the logo path */}
            <img 
              src="/company_logo.jpg" // Path to your logo in public folder
              alt="Brasotech Investments Logo"
              className="h-10 w-auto" // Adjust height as needed
              onError={(e) => {
                e.target.onerror = null; // Prevent infinite loop
                // Fallback to text if logo fails to load
                e.target.style.display = 'none';
                const parent = e.target.parentElement;
                if (parent) {
                  const fallback = document.createElement('div');
                  fallback.className = 'h-10 w-10 bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg flex items-center justify-center text-white font-bold text-sm';
                  fallback.textContent = 'BI';
                  parent.insertBefore(fallback, parent.firstChild);
                }
              }}
            />
            <div>
              <span className="text-xl font-bold text-gray-800">Brasotech</span>
              <span className="text-sm text-blue-600 block md:inline md:ml-1">Investments Limited</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium"
              >
                {item.name}
              </Link>
            ))}

            {/* User/Auth Section - Only show if user is logged in */}
            {user && (
              <div className="flex items-center space-x-4">
                <div className="relative group">
                  <button className="flex items-center space-x-2 text-gray-700 hover:text-blue-600">
                    <FaUser className="h-5 w-5" />
                    <span>{user.name || user.email}</span>
                  </button>
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-2 hidden group-hover:block">
                    {isAdmin() && (
                      <Link
                        to="/admin"
                        className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                      >
                        Admin Dashboard
                      </Link>
                    )}
                    <button
                      onClick={handleLogout}
                      className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-700 focus:outline-none"
          >
            {isOpen ? <FaTimes className="h-6 w-6" /> : <FaBars className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden bg-white border-t mt-2 py-4">
            {/* Mobile Logo */}
            <div className="flex items-center px-4 mb-4">
              <img 
                src="/logo.png" // Same logo for mobile
                alt="Brasotech Investments Logo"
                className="h-8 w-auto mr-3"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                  const parent = e.target.parentElement;
                  if (parent) {
                    const fallback = document.createElement('div');
                    fallback.className = 'h-8 w-8 bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg flex items-center justify-center text-white font-bold text-sm mr-3';
                    fallback.textContent = 'BI';
                    parent.insertBefore(fallback, parent.firstChild);
                  }
                }}
              />
              <div>
                <div className="font-bold text-gray-800">Brasotech</div>
                <div className="text-xs text-blue-600">Investments Limited</div>
              </div>
            </div>

            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="block py-2 px-4 text-gray-700 hover:bg-gray-100"
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            
            {/* Mobile User Section - Only show if user is logged in */}
            {user && (
              <>
                {isAdmin() && (
                  <Link
                    to="/admin"
                    className="block py-2 px-4 text-gray-700 hover:bg-gray-100"
                    onClick={() => setIsOpen(false)}
                  >
                    Admin Dashboard
                  </Link>
                )}
                <button
                  onClick={() => {
                    handleLogout();
                    setIsOpen(false);
                  }}
                  className="block w-full text-left py-2 px-4 text-gray-700 hover:bg-gray-100"
                >
                  Logout
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;